export default "__VITE_ASSET__5hDJP05B__"